import { css } from 'styled-components';
import { getColorShade, getHintColor } from '../../../../src/styled/utils';
export const defaultDropzoneCSS = css `
  background-color: ${getColorShade('surface', 'highEmphasis')};
`;
export const disabledDropzoneCSS = css `
  background-color: ${getColorShade('onSurface', 'hover')};

  & > p,
  span {
    color: ${getColorShade('onSurface', 'lowEmphasis')};
  }
`;
export const focusedDropzoneCSS = css `
  background-color: ${getColorShade('primary', 'focused')};
  border-color: ${getColorShade('primary', 'highEmphasis')};
`;
export const focusedUrlDropzoneCSS = css `
  border-color: ${getColorShade('primary', 'lowEmphasis')};
`;
export const dragActiveDropzoneCSS = css `
  background-color: ${getColorShade('primary', 'hover')};
  border-color: ${getColorShade('primary', 'highEmphasis')};
`;
export const dragRejectedCSS = css `
  border-color: ${getColorShade('danger', 'highEmphasis')};
`;
export const hintBorderDropzoneCSS = css `
  border-color: ${({ hintType }) => getHintColor(hintType)};
`;
